import { baseRestApi } from "api/rest/baseRestApi";

import { Tag } from "./types";
module.hot?.accept();

const createTagApi = baseRestApi.enhanceEndpoints({ addTagTypes: ["TAGS"] }).injectEndpoints({
  overrideExisting: module.hot?.status() === "apply",
  endpoints: (builder) => ({
    createTag: builder.mutation<{ data: { tag: Tag } }, { tag: string }>({
      query: (input) => ({
        method: "POST",
        url: "shipper/tags",
        body: input,
      }),
      invalidatesTags: ["TAGS"],
    }),
  }),
});

export const { useCreateTagMutation } = createTagApi;
